import { makeChartComp } from '../../util/makeChartComp';
var ScatterChart = makeChartComp('Scatter');
export default ScatterChart;
